export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9991.50de40ca.jpg";